// Moderation policies. Sections, top to bottom: the policies list, the policy overview, a
// category page, the test panel and the save bar (PortalPage.Footer).

// Policies list

.policyList {
  // Presets have different heights; keep the reader's position when the preview changes.
  overflow-anchor: none;
}

.policyTitle {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.headerActions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

// Policy overview

.overviewAction {
  min-width: 9.5rem;
}

// Test panel

.testTabs {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.testWhy {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.5rem 0 0.25rem;
}

.testStatus,

.testCategory {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.testEvidence {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0.25rem 0 0;
  padding-block: 0;
  padding-inline: 0.75rem 0;
  border-inline-start: 2px solid var(--color-border);
  color: var(--color-muted);
  font-size: 0.875rem;
  list-style: none;
}

// Change list (footer summary and save confirmation)

.saveSummary {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.changeList {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin: 0;
  padding: 0;
  list-style: none;

  > li {
    display: flex;
    align-items: flex-start;
    gap: 0.625rem;
    padding: 0.5rem 0.625rem;
    border-radius: var(--radius-md);
    background: var(--color-surface-subtle);
    font-size: 0.8125rem;
  }
}

// Save bar

.saveStatus {
  display: flex;
  min-width: 0;
  flex: 1 1 16rem;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;

  > p {
    margin: 0;
  }
}

.saveIdle {
  color: var(--color-muted);
}

.saveActions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}
